export default "__VITE_ASSET__cv7iSkcC__"